import { cn } from '../ui/utils';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  /**
   * Test ID for testing purposes
   * @default 'container'
   */
  testId?: string;
}

const sizeClasses = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  xl: 'max-w-[1920px]',
  full: 'max-w-full',
};

/**
 * Container - Responsive layout container with predefined max-widths
 * 
 * Follows mobile-first approach with consistent horizontal padding.
 * 
 * @example
 * ```tsx
 * <Container size="lg">
 *   <h1>Content here</h1>
 * </Container>
 * ```
 */
export function Container({ 
  children, 
  className, 
  size = 'xl',
  testId = 'container'
}: ContainerProps) {
  return (
    <div 
      className={cn('mx-auto w-full px-4 sm:px-6 lg:px-8', sizeClasses[size], className)}
      data-testid={testId}
    >
      {children}
    </div>
  );
}
